import "./styles.scss";

import InputFormField from "components/form/input";
import CleanButton from "components/utils/CleanButton";
import { useQueryDict } from "hooks/app";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { IoCloseCircle, IoSearch } from "react-icons/io5";

import { InputAdornment } from "@mui/material";

const CardSearch = ({ className = "", onSearchChange, placeholder = "" }) => {
  const { queryDict } = useQueryDict();
  const [searchTx, setSearchTx] = useState("");

  useEffect(() => {
    setSearchTx(queryDict.search_tx || "");
  }, [queryDict.search_tx]);

  const onChange = (e) => {
    const value = e.target?.value;
    setSearchTx(value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    onSearchChange(e.target?.searchTx?.value || undefined);
  };

  const onClear = () => {
    setSearchTx("");
    onSearchChange(undefined);
  };

  return (
    <div className={`card-search-container ${className}`}>
      <form onSubmit={onSubmit}>
        <InputFormField
          label=""
          name="searchTx"
          value={searchTx}
          className="search-input"
          placeholder={placeholder}
          onChange={onChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="end">
                <IoSearch className="search-input-icon" />
              </InputAdornment>
            ),
            endAdornment: !!searchTx && (
              <InputAdornment position="end">
                <IoCloseCircle className="clear-input-icon" onClick={onClear} />
              </InputAdornment>
            ),
          }}
        />
      </form>
    </div>
  );
};

CardSearch.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired,
};

export default CardSearch;
